import { render, staticRenderFns } from "./Giftcard.vue?vue&type=template&id=3da84154&scoped=true"
import script from "./Giftcard.vue?vue&type=script&lang=js"
export * from "./Giftcard.vue?vue&type=script&lang=js"
import style0 from "./Giftcard.vue?vue&type=style&index=0&id=3da84154&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da84154",
  null
  
)

export default component.exports